module.exports = __webpack_public_path__ + "img/marker-oil-export-grey.458f2286.png";